module.exports = __webpack_public_path__ + "static/media/onboarding-admin-step2.ad6004d9.svg";